module.exports = __webpack_public_path__ + "img/umbrella.c2f7fa6a.svg";